export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8667.d4959814.jpg";